import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';

export const useCurvesTimes = () => {
    const history = useHistory();

    const [curvesTimes, setCurvesTimes] = useState([]);
    const [idTime, setIdTime] = useState(0);

    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [method, setMethod] = useState("");

    const [createSweet] = useSweetAlert();
    const [loading, setLoading] = useState(false);
    const [searchCurves, setSearchCurves] = useState("");

    const [formValues, handleInputChange,reset,  handleUpdateValues] = useForm({
        label: "",
        time_in_minutes: 0
    });

    const [curveTimeSearch, setCurveTimeSearch] = useState([]);
    


    const { label, time_in_minutes } = formValues;
    console.log("🚀 ~ useCurvesTimes ~ formValues:", formValues)

    const [validations, setValidations] = useState({
        label_valid: false,
        time_valid: false
    });

    
    const toggle = () => {
        setModal(prev => !prev);
    }

    const closeModalCurves = () => {
        setModal(false);
    };

    const getTimes = async () => {
        let requestOptions = { method: 'GET' };

        const response = await sendRequest(requestOptions, "CurvesTime/List");

        if (response.code === 200) {
            setCurvesTimes(response.data);
            setCurveTimeSearch(response.data);
        } else {
            setCurvesTimes([]);
        }
    };

    useEffect(() => {
        getTimes();
    }, []);

    const handleCreate = () => {
        handleUpdateValues({
            label: "",
            time_in_minutes: 0
        });

        setValidations({ label_valid: false, time_valid: false });
        setIdTime(0);
        setMethod("create");
        setModalTitle("Crear Nuevo Tiempo");
        toggle();
    };

    const saveCreate = async (e) => {
        e.preventDefault();
        if (validarForm()) return;

        setLoading(true);

        let data = JSON.stringify(formValues);

        let requestOptions = { 
            method: 'POST', 
            body: data
        };

        const respuesta = await sendRequest(requestOptions, "CurvesTime/Create");

        if (respuesta.code === 200) {
            setLoading(false);
            createSweet("create", "success", "Éxito!", "Se creó correctamente");
            toggle();
            getTimes();
            handleUpdateValues({ label: "", time_in_minutes: 0 });
        } else if (respuesta.code === 409) {
            setLoading(false);
            createSweet("create", "error", "Error", respuesta.msg || "El tiempo ya existe, no se puede duplicar los tiempos.")
        } else {
            setLoading(false);
            validarSesion(history, handleCreate);
        }
    };

    const handleUpdate = (id_curve_time) => {
        let time = curvesTimes.find(x => x.id_curve_time === parseInt(id_curve_time));

        handleUpdateValues({
            label: time.label,
            time_in_minutes: time.time_in_minutes
        });

        setValidations({ label_valid: false, time_valid: false });
        setIdTime(id_curve_time);
        setMethod("update");
        setModalTitle("Actualizar tiempo de curva");
        toggle();
    };

    const saveUpdate = async (e) => {
        e.preventDefault();
        if (validarForm()) return;

        setLoading(true);

        const mValues = { 
            id_curve_time: idTime, 
            ...formValues 
        };
        
        const data = JSON.stringify(mValues);

        const requestOptions = { 
            method: 'PUT', 
            body: data 
        };

        const response = await sendRequest(requestOptions, "CurvesTime/Update");

        if (response.code === 200) {
            getTimes();
            createSweet("update", "info", "Éxito!", "Se actualizó correctamente");
            setLoading(false);
            toggle();
        } else if (response.code === 409) {
            createSweet("update", "error", "Error", response.msg || "El tiempo ya existe, no se puede duplicar el tiempo.");
            setLoading(false);
        } else if (response.code === 401) {
            validarSesion(history, response.code, saveUpdate);
        } else if (response.code === 500) {
            createSweet("error", "error", "CurvesTime", "Ocurrió un error en el servidor");
            setLoading(false);
        } else {
            createSweet("error", "warning", "CurvesTime", response.msg || "Ocurrió un error inesperado");
            setLoading(false);
        }
    };

    const handleDelete = (id_curve_time) => {
        let time = curvesTimes.find(x => x.id_curve_time === parseInt(id_curve_time));
        handleUpdateValues({
            label: time.label,
            time_in_minutes: time.time_in_minutes
        });

        setIdTime(id_curve_time);
        setMethod("delete");
        setModalTitle("Eliminar Tiempo");
        toggle();
    };

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);
        let requestOptions = { 
            method: 'DELETE' 
        };

        const response = await sendRequest(requestOptions, `CurvesTime/${idTime}`);

        if (response.code === 200) {
            getTimes();
            setLoading(false);
            createSweet("delete", "info", "Éxito!", "Se eliminó correctamente");
            toggle();
        } else if (response.code === 401) {
            validarSesion(history, response.code, saveDelete);
        } else if (response.code === 500) {
            createSweet("error", "error", "CurvesTime", "Ocurrió un error en el servidor");
        } else {
            createSweet("error", "warning", "CurvesTime", response.data.msg);
        }
    };

    const validarForm = () => {
        let statusValidation = false;
        let newValidations = {};

        if (formValues.label === "" || formValues.label.length < 3) {
            newValidations = { ...newValidations, label_valid: true };
            statusValidation = true;
        } else {
            newValidations = { ...newValidations, label_valid: false };
        }

        if (formValues.time_in_minutes === null || formValues.time_in_minutes === undefined || formValues.time_in_minutes === "") {
            newValidations = { ...newValidations, time_valid: true };
            statusValidation = true;
        } else {
            newValidations = { ...newValidations, time_valid: false };
        }

        setValidations(newValidations);
        return statusValidation;
    };

    const handleSearch = (value) => {
        setSearchCurves(value);
        const busqueda = value.toUpperCase();

        const filtered = curvesTimes.filter(element => {
            const label = element.label?.toString().toUpperCase() || "";
            const time = element.time_in_minutes?.toString().toUpperCase() || "";

            return label.includes(busqueda) || time.includes(busqueda);
        });

        setCurveTimeSearch(filtered);
    };

    const handleClearSearch = () => {
        setSearchCurves("");
        setCurveTimeSearch(curvesTimes);
    };



    return {
        curvesTimes, method,
        label, time_in_minutes, handleInputChange, validations,
        toggle, modal, modalTitle, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete, formValues, handleSearch, curveTimeSearch,closeModalCurves, handleClearSearch
    };
};

